const chefConfig = {
  "이태리 파브리 Italy Fabri": {
    slug: "fabri",
    displayName: "이태리 파브리",
    heroTitle: "파브리의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 파브리의 요리를 찾아보세요!",
    heroTitleEn: "Fabri's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Fabri's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@italyfabri",
    instagramUrl: "https://www.instagram.com/fabrilicious/",
    featuredIds: ['51e58df4-9abb-4d5c-9e6b-74308867d8ad','56676b94-f519-483d-8ad9-3d27326f2fbb','7c149bf3-43cf-43cc-b38b-ee8aeee87349'],
    triedItIds: ['446eeb0a-40a2-4203-9163-e4b63d8bb47e','75ee7e63-f240-4bb5-9e4f-a71cbcfdafed','a75ab886-788b-4690-938f-7395b5beec5a'],
  },
  "셰프호윤 Chef Hoyoon": {
    slug: "hoyoon",
    displayName: "셰프호윤",
    heroTitle: "셰프호윤의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 셰프호윤의 요리를 찾아보세요!",
    heroTitleEn: "Chef Hoyun's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Chef Hoyun's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@chefhoyoon",
    instagramUrl: "https://www.instagram.com/chefhoyoon/",
    featuredIds: ['674ad049-685f-40de-b97b-17ca730714ba','7852b65c-7e6b-4142-a681-82bf7feb045f','9ab10972-3d8f-4b75-b677-09cffc64a42d'],
    triedItIds: ['54891fdb-1976-498f-9d39-0f219ccceba3','38eccdae-9c8f-41e4-9b95-0acaec0be1b3','242a55b8-d57c-403b-8950-f5db69825c53'],
  },
  "미뇨끼": {
    slug: "minyokki",
    displayName: "미뇨끼",
    heroTitle: "미뇨끼의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 미뇨끼의 요리를 찾아보세요!",
    heroTitleEn: "Minyokki's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Minyokki's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@미뇨끼",
    instagramUrl: "https://www.instagram.com/minyo_kki/",
    featuredIds: ['d2ed17c2-2f36-4980-ab45-ad3e262d291b','2ffbc320-1dcd-457a-a4b4-7f51c42c6bd0','8406b661-b19a-4cdc-8745-9d360a360d08'],
    triedItIds: ['745d1dac-2b08-4fd9-a83d-a0bf70b3c85c','e8d95ff1-1b0e-4672-b7fb-6927210248fc','6ec47259-d083-40dc-9947-2f8695d63cbe'],
  },
  "1분다이어터 1mindiet": {
    slug: "1mindiet",
    displayName: "1분다이어터",
    heroTitle: "1분다이어터의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 1분다이어터의 요리를 찾아보세요!",
    heroTitleEn: "1mindiet's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find 1mindiet's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@1mindiet",
  },
  "강레오 걍레오": {
    slug: "leokang",
    displayName: "강레오",
    heroTitle: "강레오의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 강레오의 요리를 찾아보세요!",
    heroTitleEn: "Gangreo's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Gangreo's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@justleo55",
    instagramUrl: "https://www.instagram.com/justleo_official/",
  },
  "한신희": {
    slug: "shinheecal",
    displayName: "한신희",
    heroTitle: "한신희의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 한신희의 요리를 찾아보세요!",
    heroTitleEn: "Shinhee's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Shinhee's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@shinheecal",
    instagramUrl: "https://www.instagram.com/_xinhann/",
  },
  "김밀란": {
    slug: "kimmilan",
    displayName: "김밀란",
    heroTitle: "김밀란의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 김밀란의 요리를 찾아보세요!",
    heroTitleEn: "Kimmilan's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Kimmilan's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@Kimmilan",
    instagramUrl: "https://www.instagram.com/milan__kim/",
  },
  "유지만 yuziman": {
    slug: "yuziman",
    displayName: "유지만",
    heroTitle: "유지만의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 유지만의 요리를 찾아보세요!",
    heroTitleEn: "Yuziman's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Yuziman's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@유지만",
  },
  "1분요리 뚝딱이형": {
    slug: "1mincook",
    displayName: "1분요리 뚝딱이형",
    heroTitle: "뚝딱이형의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 뚝딱이형의 요리를 찾아보세요!",
    heroTitleEn: "1mincook's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find 1mincook's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@1mincook",
  },
  "자취요리신 simple cooking": {
    slug: "simplecooking",
    displayName: "자취요리신",
    heroTitle: "자취요리신의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 자취요리신의 요리를 찾아보세요!",
    heroTitleEn: "Simplecooking's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Simplecooking's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@자취요리신simplecooking",
  },
  "어쿠스틱 드링크": {
    slug: "acoustic-drink",
    displayName: "어쿠스틱드링크",
    heroTitle: "어쿠스틱드링크의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 어쿠스틱드링크의 음료를 찾아보세요!",
    heroTitleEn: "Acoustic Drink's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Acoustic Drink's recipes with what you have!",
    youtubeUrl: "https://www.youtube.com/@어쿠스틱드링크",
    instagramUrl: "https://www.instagram.com/acousticdrink",
  },
  "지미스테이블 Jimmy's Table": {
    slug: "jimmys-table",
    displayName: "지미스테이블",
    heroTitle: "지미스테이블의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 지미스테이블의 요리를 찾아보세요!",
    heroTitleEn: "Jimmy's Table Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Jimmy's Table dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@지미스테이블jimmys_table",
  },
  "백종원 PAIK JONG WON": {
    slug: "paikjongwon",
    displayName: "백종원",
    heroTitle: "백종원의 레시피\n재료로 바로 찾기",
    heroSubtitle: "내 재료로 백종원의 요리를 찾아보세요!",
    heroTitleEn: "Paik Jongwon's Recipes\nFind by Ingredients",
    heroSubtitleEn: "Find Paik Jongwon's dishes with what you have!",
    youtubeUrl: "https://www.youtube.com/@paik_jongwon",
  },
};

export const slugToKey = Object.entries(chefConfig).reduce((acc, [key, val]) => {
  if (val?.slug) acc[val.slug] = key;
  return acc;
}, {});

export default chefConfig;
